import * as React from "react"
import * as classnames from "classnames"

require("./styles/index.styl")

interface Props {
    readonly className?: string
    readonly style?: React.CSSProperties
    readonly gta?: string
    readonly type?: "primary" | "secondary"
    readonly size?: "normal" | "small"
    readonly onClick?: () => void
}

export class Button extends React.PureComponent<Props> {
    rootClassName = "tb-button"

    static readonly defaultProps = {
        type: "primary",
        size: "normal"
    }

    render() {
        const { type, size, onClick, className } = this.props

        const onClickButton = () => {
            if (this.props.onClick) {
                onClick()
            }
        }

        const cls = classnames({
            [`${this.rootClassName}-${type}`]: true,
            [`${this.rootClassName}-${size}`]: true,
            [`${className}`]: !!className
        })

        return (
            <button
                className={ cls }
                onClick={ onClickButton }
                data-role={ `${this.rootClassName}` }
                data-content={ this.props.children }
                style={ this.props.style }
                data-gta={ this.props.gta }
            >
                {this.props.children}
            </button>
        )
    }
}
